export default __webpack_public_path__ + "static/media/flag_of_bonaire.30ca5835.svg";